export enum DescendantsStrategy {
  ALL = 'ALL',
  DIRECT = 'DIRECT',
}
